import axios from '@/jslib/axios'

export const getRenewalList = (params, other) => {
  return axios({
    method: 'get',
    url: '/admin/renewal/list',
    params,
    ...other
  })
}

export const renewOrderSave = data => {
  return axios({
    method: 'post',
    url: '/admin/renewal/order/save',
    data
  })
}

export const renewReplyCase = params => {
  return axios({
    method: 'get',
    url: '/admin/renewal/reply/case',
    params
  })
}

export const getRenewReferUnderwriting = params => {
  return axios({
    method: 'get',
    url: '/admin/renewal/plan/optional',
    params
  })
}

export const getRenewalPlanBenefit = data => {
  return axios({
    method: 'post',
    url: '/admin/renewal/plan/benefit',
    data
  })
}

export const getRenewPremiumData = params => {
  return axios({
    method: 'get',
    url: '/admin/renewal/premium/data',
    params
  })
}

export const getRenewMain = data => {
  return axios({
    method: 'post',
    url: '/admin/renewal/main',
    data
  })
}

export const renewReply = data => {
  return axios({
    method: 'post',
    url: '/admin/renewal/reply',
    data
  })
}

export const renewQuoteDel = data => {
  return axios({
    method: 'post',
    url: '/admin/renewal/quote/del',
    data
  })
}

export const renewBuyQuoteList = data => {
  return axios({
    method: 'post',
    url: '/admin/renewal/buy/quote',
    data
  })
}

export const renewReplySend = data => {
  return axios({
    method: 'post',
    url: '/admin/renewal/reply/send',
    data
  })
}

export const renewBuyPolicy = data => {
  return axios({
    method: 'post',
    url: '/admin/renewal/buy/policy',
    data
  })
}

export const renewRemind = data => {
  return axios({
    method: 'post',
    url: '/admin/renewal/remind/cancel',
    data
  })
}

export const getRenewPersonalCoverage = data => {
  return axios({
    method: 'post',
    url: '/admin/renewal/accident/cvr_opt',
    data
  })
}

export const getRenewPersonalBenifit = data => {
  return axios({
    method: 'post',
    url: '/admin/renewal/accident/benefit_opt',
    data
  })
}

export const getRenewHomeExcess = data => {
  return axios({
    method: 'post',
    url: '/admin/renewal/home/excess',
    data
  })
}